import { render, staticRenderFns } from "./CadastroConfigsSMTP.vue?vue&type=template&id=79bd0d53&scoped=true"
import script from "./CadastroConfigsSMTP.vue?vue&type=script&lang=js"
export * from "./CadastroConfigsSMTP.vue?vue&type=script&lang=js"
import style0 from "./CadastroConfigsSMTP.vue?vue&type=style&index=0&id=79bd0d53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd0d53",
  null
  
)

export default component.exports